<section class="desktop">
  <i class="fa-light fa-phone mr-8"></i>
  <p class="body bold" [class.large]="vm.largeFont">
    {{ vm.phoneNumber }}
  </p>
</section>

<section class="mobile">
  @if (!vm.useButtonOnMobile) {
    <i class="fa-light fa-phone mr-8"></i>
    <a [href]="'tel:' + vm.sanitizedPhoneNumber" class="flex body bold">
      {{ vm.phoneNumber }}
    </a>
  } @else {
    <section class="mob-button-styling">
      <app-button dataLabel="telephone" class="ml-auto md-ml-0 sm-full-width">
        <section class="text">
          @if (!vm.buttonLabel) {
            <i class="fa-light fa-phone mr-8"></i>
          }
          <a [href]="'tel:' + vm.sanitizedPhoneNumber" class="flex body bold">
            {{ vm.buttonLabel ?? vm.phoneNumber }}
          </a>
        </section>
      </app-button>
    </section>
  }
</section>

<ng-content />

@if (postCodeMessaging() && !vm.hidePostCodeMessaging) {
  <p data-testid="call-cost-messaging" class="hint mt-8 {{ postCodeMessagingClasses() ?? '' }}">
    {{ postCodeMessaging() }}
  </p>
}
